import { useEffect, useRef, useState } from 'react';
import { socketService } from '../services/socket';
import { useAuth } from '../context/AuthContext';
import { useSocketContext } from '../context/SocketContext';

export const useSocket = () => {
  return useSocketContext();
};

export const useSocketAuth = () => {
  const socket = useSocketContext();
  const { user, isAuthenticated } = useAuth();
  const [isSocketAuthenticated, setIsSocketAuthenticated] = useState(false);
  const [isReconnecting, setIsReconnecting] = useState(false);
  const authAttemptRef = useRef(0);

  useEffect(() => {
    if (!socket || !isAuthenticated || !user) {
      setIsSocketAuthenticated(false);
      return;
    }

    console.log('useSocketAuth: Авторизуем сокет для пользователя', user.userNumber);

    const authenticateSocket = async () => {
      try {
        authAttemptRef.current += 1;
        const attemptNumber = authAttemptRef.current;

        console.log(`useSocketAuth: Попытка авторизации #${attemptNumber}`);
        setIsReconnecting(true);

        const success = await socket.authenticate(user.id, user.userNumber);

        if (attemptNumber === authAttemptRef.current) {
          setIsSocketAuthenticated(success);
          setIsReconnecting(false);
          console.log(success ? 'useSocketAuth: Авторизация успешна' : 'useSocketAuth: Авторизация не удалась');
        }
      } catch (error) {
        console.error('useSocketAuth: Ошибка авторизации:', error);
        if (authAttemptRef.current === authAttemptRef.current) {
          setIsSocketAuthenticated(false);
          setIsReconnecting(false);
        }
      }
    };

    const unsubscribeAuthenticated = socket.on('authenticated', (data) => {
      console.log('useSocketAuth: Получено событие authenticated:', data);
      setIsSocketAuthenticated(data.success);
      setIsReconnecting(false);
    });

    const unsubscribeAuthError = socket.on('authentication_error', (data) => {
      console.error('useSocketAuth: Получена ошибка авторизации:', data);
      setIsSocketAuthenticated(false);
      setIsReconnecting(false);
    });

    const unsubscribeConnect = socket.on('connect', () => {
      console.log('useSocketAuth: Сокет подключился, начинаем авторизацию');
      setIsReconnecting(true);
      authenticateSocket();
    });

    const unsubscribeDisconnect = socket.on('disconnect', () => {
      console.log('useSocketAuth: Сокет отключился');
      setIsSocketAuthenticated(false);
      setIsReconnecting(false);
    });

    const unsubscribeJoinedGroup = socket.on('joined_group', (data) => {
      console.log('useSocketAuth: Пользователь присоединился к группе:', data);
    });

    const unsubscribeLeftGroup = socket.on('left_group', (data) => {
      console.log('useSocketAuth: Пользователь покинул группу:', data);
    });

    const socketInstance = socket.getSocket();
    if (socketInstance?.connected && !socket.getAuthenticationStatus()) {
      authenticateSocket();
    } else if (!socketInstance?.connected) {
      console.log('useSocketAuth: Сокет не подключен, ждем подключения');
      setIsReconnecting(true);
    } else if (socket.getAuthenticationStatus()) {
      setIsSocketAuthenticated(true);
    }

    return () => {
      unsubscribeAuthenticated();
      unsubscribeAuthError();
      unsubscribeConnect();
      unsubscribeDisconnect();
      unsubscribeJoinedGroup();
      unsubscribeLeftGroup();
    };
  }, [socket, user, isAuthenticated]);

  return {
    socket,
    user,
    isAuthenticated,
    isSocketAuthenticated,
    isReconnecting,
    pendingEventsCount: socket?.getPendingEventsCount() || 0,
  };
};
